import { Feature, FeatureIds } from "../../../domain/entities/product/Features";

type Distrubution = FeatureIds[];

const DISTRIBUTION_BY_FEATURES: Record<string, Distrubution> = {
  description: [
    FeatureIds.TOP_TYPE,
    FeatureIds.OUTSIDE_TYPE,
    FeatureIds.PRINT,
    FeatureIds.NECKLINE,
    FeatureIds.DETAIL,
    FeatureIds.CLOSING,
    FeatureIds.SKIRT_TYPE,
    FeatureIds.DOWN_PART_TYPE,
    FeatureIds.SHOT,
    FeatureIds.DRESS_TYPE,
    FeatureIds.JUMP_SUIT_TYPE,
    FeatureIds.NECK,
    FeatureIds.SHOE_TYPE,
    FeatureIds.TOECAP,
    FeatureIds.SOLE_TYPE,
    FeatureIds.HEEL_TYPE,
    FeatureIds.BAG_TYPE,
    FeatureIds.FOULARD_TYPE,
  ],
  sizeAndFit: [
    FeatureIds.FIT,
    FeatureIds.LONG_CM,
    FeatureIds.SLEEVE_LONG_CM,
    FeatureIds.SIZING,
    FeatureIds.TYPE_OF_LENGTH,
    FeatureIds.HEEL_LENGTH,
    FeatureIds.LEG_LENGTH,
  ],
  composition: [FeatureIds.COMPOSITION, FeatureIds.FABRIC],
  garmentCare: [FeatureIds.GARMENT_CARE],
};

const useGetDistributionByFeatures = (features: Feature[]) => {
  if (!features) {
    return null;
  }

  return {
    description: features.filter((feature: Feature) =>
      DISTRIBUTION_BY_FEATURES.description
        ? DISTRIBUTION_BY_FEATURES.description.includes(feature.id as FeatureIds)
        : false,
    ),
    sizeAndFit: features.filter((feature: Feature) =>
      DISTRIBUTION_BY_FEATURES.sizeAndFit
        ? DISTRIBUTION_BY_FEATURES.sizeAndFit.includes(feature.id as FeatureIds)
        : false,
    ),
    composition: features.filter((feature: Feature) =>
      DISTRIBUTION_BY_FEATURES.composition
        ? DISTRIBUTION_BY_FEATURES.composition.includes(feature.id as FeatureIds)
        : false,
    ),
    garmentCare: features.filter((feature: Feature) =>
      DISTRIBUTION_BY_FEATURES.garmentCare
        ? DISTRIBUTION_BY_FEATURES.garmentCare.includes(feature.id as FeatureIds)
        : false,
    ),
  };
};

export { useGetDistributionByFeatures };
